import { AutogenModelMovementLookup, AutogenRowMovementLookup } from "./autogen/AutogenModelMovementLookup";

export class ModelMovementLookup extends AutogenModelMovementLookup<RowMovementLookup> {
	constructor() {
		super(RowMovementLookup);
	}
}

export class RowMovementLookup extends AutogenRowMovementLookup {
}